import React from "react";

import cx from "classnames";

import styles from "./Buttons.module.scss";
import ButtonBase from "./ButtonBase";

export default function ButtonSecondary({ children, className, ...props }) {
  return (
    <ButtonBase className={cx(styles.secondary, className)} {...props}>
      {children}
    </ButtonBase>
  );
}
